module.exports = __webpack_public_path__ + "img/if.ac578997.jpg";